module.exports = __webpack_public_path__ + "assets/img/android-big.507077dd.svg";